var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"subtitle-1"},[_vm._v("Список студентів, які мають завантажені документи для (певних) пропусків")])]),_c('v-flex',{attrs:{"xs12":""}},[_c('admissions-student-list',{attrs:{"students":_vm.students,"loading":_vm.loading}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }